import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { Navigate , Route } from "react-router-dom"; 
import MUIDataTable from "mui-datatables";
import Header  from './header';
import BreadCrumb from './breadcrumb';
class UsersData extends Component{
    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            username:'',
            password:'',
            users: []
        };
 
    }

    componentDidMount(){
      let self = this;
      var loaderElement = document.querySelector('#load_screen');
      setTimeout( function() {
          loaderElement.style.display = "none";
      }, 3000); 
      if(localStorage.getItem("ROLE") == "Admin" &&  localStorage.getItem("isAuth") == "true"){
      
      }else{
        return (document.write("Un authorized Access"))
      }
      var getDetails = new FormData(); 
      getDetails.append('OP', 'getAllUsers');
      axios.post('http://sktrading.biz/BMSCalls/users.php',getDetails)
      .then(function (response) {
        console.log("RESPONSe",response.data); 
        var data = [];
         for(var i = 0; i < response.data.response.length; i++){
         
      //data = [[response.data.response[i]['name'], response.data.response[i]['email'],response.data.response[i]['status'],response.data.response[i]['role']],]
        
      data.push(
        [response.data.response[i]['name'], response.data.response[i]['email'],response.data.response[i]['status'],response.data.response[i]['plain_password'],response.data.response[i]['role']],
        )
        }
        self.setState({users:data});
       // console.log("YOOO",data); 
       })
       .catch(function (error) {

        console.log(error);

      });

     //

     

    };

 
   
    render (){
        const columns = ["Name", "Email", "Status","Password","Role"];
        const data = [
          ["Joe James", "Test Corp", "Yonkers", "NY"],
          ["John Walsh", "Test Corp", "Hartford", "CT"],
          ["Bob Herm", "Test Corp", "Tampa", "FL"],
          ["James Houston", "Test Corp", "Dallas", "TX"],
          ];
  
     //  console.log("real",data)

        const options = {
        onRowsDelete:(e)=>{console.log("Dhaisu",e.data)},
        filterType: 'checkbox',
        print: false
        };
        if(localStorage.getItem("ROLE") == "Admin" &&  localStorage.getItem("isAuth") == "true"){     
         
        return(
        <div>
        {/* BEGIN LOADER */}
        <div id="load_screen"> <div className="loader"> <div className="loader-content">
            <div className="spinner-grow align-self-center" />
        </div></div></div>
        {/*  END LOADER */}
          {/*  BEGIN NAVBAR  */}
          <Header/>
        {/*  END NAVBAR  */}
        <div className="main-container" id="container">
          <div className="overlay" />
          <div className="search-overlay" />
 
          <div id="content" className="main-content">
            <div className="layout-px-spacing">
             <BreadCrumb/>
              <div className="row layout-top-spacing layout-spacing">
              <div id="flLoginForm" className="col-lg-12 layout-spacing">
              <MUIDataTable
                title={"All Users"}
                data={this.state.users}
                columns={columns}
                options={options}
                />
              </div> </div>
            </div>
            <div className="footer-wrapper">
                <div className="footer-section f-section-1">
                  <p className>Copyright © 2021 <a target="_blank" href>YMS</a>, All rights reserved.</p>
                </div>
                <div className="footer-section f-section-2">
                  <p className>Coded with <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg></p>
                </div>
              </div>
        </div> 
        </div>
       

   
        </div>
        );
      }else{
        return("Unauthorized Access")
      } 
    }
}
export default UsersData;